export const STOP_MARKER_SIZE = 28;
export const STOP_MARKER_COLOR = "#EF4444";

const STOP_MARKER_SVG =
  '<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">' +
  `<rect x="2" y="2" width="28" height="28" rx="3" fill="${STOP_MARKER_COLOR}" ` +
  'stroke="#ffffff" stroke-width="2.5"/>' +
  '<rect x="11" y="11" width="10" height="10" rx="1.5" fill="none" ' +
  'stroke="#ffffff" stroke-width="2.2"/>' +
  "</svg>";

export const STOP_MARKER_ICON_URL = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(STOP_MARKER_SVG)}`;

export const formatStopDuration = (durationMs: number): string => {
  const totalMinutes = Math.round(durationMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) return `${minutes} min`;
  return minutes === 0 ? `${hours} h` : `${hours} h ${minutes} min`;
};

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

export interface StopPopupData {
  fecha?: string | null;
  durationMs: number;
  lat: number;
  lng: number;
  location?: string | null;
}

const row = (label: string, value: string): string =>
  `<div class="map-stop-popup__row"><span class="map-stop-popup__label">${label}</span>${value}</div>`;

export const buildStopPopupHtml = ({ fecha, durationMs, lat, lng, location }: StopPopupData): string =>
  `<div class="map-stop-popup">
    <div class="map-stop-popup__title">Punto de parada</div>
    ${fecha ? row("Inicio", escapeHtml(fecha)) : ""}
    ${row("Duración", formatStopDuration(durationMs))}
    ${row("Ubicación", location == null ? "Cargando…" : escapeHtml(location))}
    ${row("Coordenadas", `${lat.toFixed(6)}, ${lng.toFixed(6)}`)}
  </div>`;
